import React, { useEffect } from 'react';

const TawkToChat = () => {
    useEffect(() => {
        if (!window.location.href.includes('dashboard')) {
            const loadTawkTo = () => {
                var Tawk_API = Tawk_API || {};
                var Tawk_LoadStart = new Date();
                (function () {
                    var s1 = document.createElement('script'),
                        s0 = document.getElementsByTagName('script')[0];
                    if (s0 && s0.parentNode) {
                        s1.async = true;
                        s1.src = 'https://embed.tawk.to/6669d16e9a809f19fb3cdfc3/1i06lk6ap';
                        s1.charset = 'UTF-8';
                        s1.setAttribute('crossorigin', '*');
                        s0.parentNode.insertBefore(s1, s0);
                    }
                })();
            };

            loadTawkTo();
        }
    }, []);

    return (
        <>
            <div id="tawk-root"></div>
        </>
    );
};

export default TawkToChat;
